<mat-form-field>
  <mat-label>Select a Harvest</mat-label>
  <mat-select [disabled]="disabled" [(value)]="harvestId">
    <mat-option>
      <ngx-mat-select-search [formControl]="harvestFilterCtrl" placeholderLabel="Search..." noEntriesFoundLabel="No matches"></ngx-mat-select-search>
    </mat-option>
    @for (h of filteredHarvests; track h) {
      <mat-option [value]="h.uid">{{h.name}}{{getDates(h)}}{{ h.completed ? ' (Completed)' : ''}}</mat-option>
    }
  </mat-select>
</mat-form-field>